<template>
  <div class="containerFull_badmintonThomasAndUber">
    <BadmintonCommon
      :bigSportsList="bigSportsList"
      :containerFullClassName="containerFullClassName"
      :defaultPath="defaultPath"
      :axiosBaseUrl="axiosBaseUrl"
      :sportCompetitionType="sportCompetitionType"
      :themeSeasonArr="themeSeasonArr"
    ></BadmintonCommon>
  </div>
</template>

<script>
// 羽毛球 汤尤杯 容器
import BadmintonCommon from './badminton_common'
import containerFull_data from '@mixins/badminton/thomasAndUber/containerFull_data'
export default {
  name: 'containerFull_badmintonThomasAndUber',
  mixins: [containerFull_data],
  components: {
    BadmintonCommon,
  },
}
</script>
